module.exports = "/_next/static/images/wanted-a0aaeb5bc20708471cfc049204b67c35.png";